import { render, staticRenderFns } from "./SimpleProductBlock.vue?vue&type=template&id=fccd6824&scoped=true"
import script from "./SimpleProductBlock.vue?vue&type=script&lang=js"
export * from "./SimpleProductBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccd6824",
  null
  
)

export default component.exports